// src/script/index.ts
var loadScriptAsync = async ({
  id,
  target = "body",
  type = "script",
  snippet,
  url
}) => {
  return new Promise((resolve, reject) => {
    const isExist = document.getElementById(id);
    if (isExist) {
      resolve(true);
    } else {
      let el;
      if (type !== "link") {
        el = document.createElement(type);
        el.type = "text/javascript";
        if (url) {
          el.src = url;
        } else {
          el.innerHTML = snippet || "";
        }
      } else {
        el = document.createElement("link");
        el.rel = "stylesheet";
        if (url) {
          el.href = url;
        } else {
          el.innerHTML = snippet || "";
        }
      }
      el.id = id;
      el.onload = resolve;
      el.onerror = reject;
      document[target].prepend(el);
    }
  });
};

export {
  loadScriptAsync
};
//# sourceMappingURL=chunk-3PGZRXGP.mjs.map